const levels = ['h1', 'h2', 'h3'] as const;

/**
 * Converts a 1-indexed level to a corresponding variant string.
 * 
 * @param level - A 1-indexed number representing the level (e.g., 1 for 'h1', 2 for 'h2').
 * @returns The corresponding variant string ('h1', 'h2', 'h3'), or 'h3' if the level is out of range.
 */
export const levelToVariant = (level: number) => {
  return levels[level - 1] || 'h3';
};
